import { TImage } from '@/services/requests/Recommendation/types/template4';

export function getImage(images: TImage[], channel: 'web' | 'app') {
  return images.find(item => item.channel.toLowerCase().includes(channel));
}
